/* ==========================================================================
   Lockett Labs recently viewed (sections/static-recently-viewed.liquid)
   Moved out of the section, unchanged, so it is cached and deferred instead of
   printed into every collection and product page (27 KB each time).
   ========================================================================== */
(function () {
  var SECTION = '[data-ll-rv]';

  /* Shared keys. `ll_recently_viewed` and `ll_rvp_*` are read by the TCG hub
     to pick which game to open on, so the names and shapes are fixed. */
  var K_HIST  = 'll_recently_viewed';
  var K_SEEN  = 'll_rv_seen';           /* additive: handle -> last viewed ms */
  var K_WATCH = 'll_watchlist';
  var K_LEGACY = 'll_preorder_watch';
  var CACHE_TTL = 900000;               /* 15 min */
  var HIST_MAX = 20;

  /* Same accent table as the watchlist alerts, so a Pokemon card is the same
     yellow wherever it appears. `ink` is the text-safe darkened pair. */
  var THEMES = [
    { id:'pokemon',      acc:'#f5b800', ink:'#9a7300', match:['pokemon','pokémon'],
      icon:'https://lockett-labs.com/cdn/shop/files/png-clipart-pokeball-pokeball-thumbnail-Photoroom.png?v=1785786875&width=64' },
    { id:'lorcana',      acc:'#7c5cff', ink:'#5a3fd4', match:['lorcana','disney'],
      icon:'https://lockett-labs.com/cdn/shop/files/lorcana_tcg_symbols___basic_ink__vector_file__by_roshmalum_dhro31k-pre.png?v=1785705932&width=64' },
    { id:'onepiece',     acc:'#2f74d0', ink:'#1f5aad', match:['one piece','onepiece'],
      icon:'https://lockett-labs.com/cdn/shop/files/cartoon-pirate-skull-with-hat-free-png.webp?v=1785717154&width=64' },
    { id:'magic',        acc:'#a5202a', ink:'#8a1b24', match:['magic the gathering','magic: the gathering',' mtg','mtg ','mtg,','wizards of the coast'],
      icon:'https://lockett-labs.com/cdn/shop/files/png-clipart-magic-the-gathering-puzzle-quest-magic-points-playing-card-symbol-symbol-miscellaneous-game-thumbnail-Photoroom.png?v=1785705960&width=64' },
    { id:'digimon',      acc:'#12a594', ink:'#0d7f72', match:['digimon'],
      icon:'https://lockett-labs.com/cdn/shop/files/terriermon-renamon-impmon-digimon-logo-png-favpng-qKkQ2jkCesxE8rkv1RRbUmp7S-Photoroom.png?v=1785786846&width=64' },
    { id:'vaultx',       acc:'#111827', ink:'#111827', match:['vault x','vaultx'], icon:null },
    { id:'ultrapro',     acc:'#c41230', ink:'#a00e28', match:['ultra pro','ultrapro'], icon:null },
    { id:'dragonshield', acc:'#e85d04', ink:'#c44e04', match:['dragon shield','dragonshield'], icon:null },
    { id:'gamegenic',    acc:'#5b2c6f', ink:'#4a235a', match:['gamegenic'], icon:null },
    { id:'cardconcept',  acc:'#0d9488', ink:'#0a7a70', match:['card concept','cardconcept'], icon:null }
  ];

  var ICO = {
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6.2 6h14.3l-2.2 8.3a2 2 0 0 1-1.9 1.5H8.4a2 2 0 0 1-2-1.6L4.6 4H2V2h4.2l.6 2.9L6.2 6Z"/></svg>',
    bell: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22a2.4 2.4 0 0 0 2.4-2.4H9.6A2.4 2.4 0 0 0 12 22Zm7-6v-5a7 7 0 0 0-5.3-6.8V3a1.7 1.7 0 0 0-3.4 0v1.2A7 7 0 0 0 5 11v5l-2 2v1h18v-1Z"/></svg>',
    x:    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12 19 6.4 17.6 5 12 10.6Z"/></svg>'
  };

  /* ---------------- storage helpers ---------------- */
  function readJSON(store, key, fb) {
    try { var v = store.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
  }
  function writeJSON(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
  function uniq(list) {
    var out = [], seen = {};
    (list || []).forEach(function (h) {
      h = String(h || '').trim();
      if (!h || seen[h]) return;
      seen[h] = 1; out.push(h);
    });
    return out;
  }
  function readHist() {
    var v = readJSON(localStorage, K_HIST, []);
    return uniq(isArr(v) ? v : []);
  }
  function writeHist(list) { writeJSON(localStorage, K_HIST, uniq(list).slice(0, HIST_MAX)); }
  function readSeenMap() {
    var m = readJSON(localStorage, K_SEEN, {});
    return (m && typeof m === 'object' && !isArr(m)) ? m : {};
  }
  function readWatch() {
    var v = readJSON(localStorage, K_WATCH, null);
    if (isArr(v)) return uniq(v);
    var legacy = readJSON(localStorage, K_LEGACY, []);
    return uniq(isArr(legacy) ? legacy : []);
  }
  function writeWatch(list) {
    var clean = uniq(list).slice(0, 100);
    /* Prefer the sync snippet when it is on the page — it handles the customer
       metafield push and fires the change event itself. */
    if (window.llWatchSync && typeof window.llWatchSync.write === 'function') {
      try { window.llWatchSync.write(clean); return clean; } catch (e) {}
    }
    writeJSON(localStorage, K_WATCH, clean);
    writeJSON(localStorage, K_LEGACY, clean);
    try {
      document.dispatchEvent(new CustomEvent('ll:watchlist:change', {
        detail: { list: clean, source: 'local' }
      }));
    } catch (e) {}
    return clean;
  }
  function dropCache(handle) {
    try { sessionStorage.removeItem('ll_rvp_' + handle); } catch (e) {}
  }

  /* ---------------- text helpers ---------------- */
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Collector number off the end of the title.
     Titles run "Name : SET (Finish) - 123/456". Only the trailing segment is
     considered, and it has to look like a number — sealed product and
     accessories fall through and simply get no chip rather than a dash. */
  var STRONG = /^[A-Za-z]{0,4}\d{1,4}(?:\s*\/\/?\s*[A-Za-z0-9]{1,6})?[A-Za-z]?$/;
  /* Set-code style: OP01-003, ST01-001, BT1-001, P-001. */
  var CODEY  = /^[A-Za-z]{1,4}\d{0,3}[-–][A-Za-z]?\d{1,4}[A-Za-z]?$/;
  function cardNumber(title) {
    var t = String(title || '');
    var cut = t.lastIndexOf(' - ');
    if (cut < 0) return '';
    var tail = t.slice(cut + 3).trim().replace(/\s*\/\/\s*/g, '//').replace(/\s*\/\s*/g, '/');
    if (!tail || tail.length > 16) return '';
    if (!/\d/.test(tail)) return '';
    if (STRONG.test(tail) || CODEY.test(tail)) return tail.toUpperCase();
    return '';
  }
  function looksSealed(hay) {
    return /sealed|booster|elite trainer|etb|bundle|display|tin|collection box|accessor|sleeve|binder|toploader|deck box|plush|figur/.test(hay);
  }

  /* Is this an actual card? Every single lives under the "single cards" tag,
     so that is the first and most reliable answer. Sealed product, accessories
     and plush are never cards. Anything left over only counts as a card if a
     collector number parses off the title. */
  function isSingleCard(p, hay) {
    var tags = (p.tags || []).join('|').toLowerCase();
    if (/single\s*cards?/.test(tags)) return true;
    if (/sealed\s*product/.test(tags) || looksSealed(hay)) return false;
    return !!cardNumber(p.title);
  }
  function agoLabel(ms) {
    if (!ms) return '';
    var d = Date.now() - ms;
    if (d < 0) return '';
    if (d < 120000) return 'Just now';
    if (d < 3600000) return Math.round(d / 60000) + 'm ago';
    if (d < 86400000) return Math.round(d / 3600000) + 'h ago';
    if (d < 604800000) return Math.round(d / 86400000) + 'd ago';
    return '';
  }

  /* ---------------- per-section boot ---------------- */
  function boot(host) {
    if (!host || host.__llrv) return;
    host.__llrv = true;

    var d = host.dataset;
    var on = function (k) { return d[k] === 'true'; };
    var cfg = {
      limit: parseInt(d.limit, 10) || 12,
      currency: d.currency || 'GBP',
      vendor: on('vendor'), price: on('price'), qa: on('qa'), second: on('second'),
      colour: on('colour'), number: on('number'), states: on('states'),
      watch: on('watchOn'), seen: on('seen'),
      low: parseInt(d.low, 10) || 0,
      comingLabel: d.comingLabel || 'Coming soon',
      watchUrl: d.watchUrl || '/pages/watchlist',
      cartUrl: d.cartUrl || '/cart'
    };
    var current = d.current || '';

    /* Repair pass: a build of this section resolved the bell with an
       unqualified [data-watch] selector, which matched the section root and
       saved its flag ("true") as though it were a product handle. Strip any
       such entry so it stops being polled by the live alerts. */
    (function () {
      var raw = readJSON(localStorage, K_WATCH, null);
      if (!isArr(raw)) return;
      var clean = raw.filter(function (h) {
        return h && h !== 'true' && h !== 'false' && h !== 'undefined' && h !== 'null';
      });
      if (clean.length !== raw.length) writeWatch(clean);
    })();

    var rail  = host.querySelector('[data-rail]');
    var nav   = host.querySelector('[data-nav]');
    var prev  = host.querySelector('[data-prev]');
    var next  = host.querySelector('[data-next]');
    var toast = host.querySelector('[data-toast]');
    var tMsg  = host.querySelector('[data-toast-msg]');
    var tLink = host.querySelector('[data-toast-link]');
    var live  = host.querySelector('[data-live]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function money(cents) {
      var v = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
          { style: 'currency', currency: cfg.currency }).format(v);
      } catch (e) { return '£' + v.toFixed(2); }
    }

    /* ---- record this view, then decide what to render ---- */
    var hist = readHist();
    if (current) {
      hist = [current].concat(hist.filter(function (h) { return h !== current; })).slice(0, HIST_MAX);
      writeHist(hist);
      var seenMap = readSeenMap();
      seenMap[current] = Date.now();
      /* Trim to what history still holds so the map cannot grow forever. */
      var keep = {};
      hist.forEach(function (h) { if (seenMap[h]) keep[h] = seenMap[h]; });
      writeJSON(localStorage, K_SEEN, keep);
    }

    var queue = hist.filter(function (h) { return h !== current; }).slice(0, cfg.limit);
    if (!queue.length) return;                     /* stays hidden */

    /* ---- product fetch, cached in sessionStorage ---- */
    function trim(p) {
      return {
        handle: p.handle, title: p.title, url: p.url || ('/products/' + p.handle),
        vendor: p.vendor, type: p.type, tags: p.tags || [],
        available: !!p.available, price: p.price,
        compare_at_price: p.compare_at_price || p.compare_at_price_max || 0,
        price_varies: !!p.price_varies, published_at: p.published_at,
        images: (p.images || []).slice(0, 2),
        featured_image: p.featured_image || '',
        variants: (p.variants || []).map(function (v) {
          return { id: v.id, available: !!v.available, inventory_quantity: v.inventory_quantity };
        })
      };
    }
    function fetchProduct(handle) {
      var key = 'll_rvp_' + handle;
      var hit = readJSON(sessionStorage, key, null);
      if (hit && hit.t && (Date.now() - hit.t) < CACHE_TTL && hit.p) return Promise.resolve(hit.p);
      return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
        .then(function (p) {
          var t = trim(p);
          writeJSON(sessionStorage, key, { t: Date.now(), p: t });
          return t;
        })
        .catch(function () { return { __dead: handle }; });
    }

    /* ---- card ---- */
    function themeFor(p) {
      if (!cfg.colour) return null;
      var hay = ' ' + [p.title, p.type, p.vendor, (p.tags || []).join(' ')].join(' ').toLowerCase() + ' ';
      for (var i = 0; i < THEMES.length; i++) {
        for (var j = 0; j < THEMES[i].match.length; j++) {
          if (hay.indexOf(THEMES[i].match[j]) > -1) return THEMES[i];
        }
      }
      return null;
    }
    function imgUrl(u, w) {
      if (!u) return '';
      if (u.indexOf('//') === 0) u = 'https:' + u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function imgTag(u, cls, alt) {
      if (!u) return '';
      var b = (u.indexOf('//') === 0) ? 'https:' + u : u;
      var set = [200, 300, 420, 560].map(function (w) { return imgUrl(b, w) + ' ' + w + 'w'; }).join(', ');
      return '<img class="' + cls + '" src="' + esc(imgUrl(b, 420)) + '" srcset="' + esc(set) +
             '" sizes="(max-width:700px) 47vw, 190px" loading="lazy" decoding="async" alt="' + esc(alt || '') + '">';
    }

    var watchSet = {};
    function refreshWatchSet() {
      watchSet = {};
      readWatch().forEach(function (h) { watchSet[h] = 1; });
    }
    refreshWatchSet();

    function chip(kind, label) {
      return '<span class="llrv__state" data-s="' + kind + '"><i></i>' + esc(label) + '</span>';
    }

    /* Release dates emitted by Liquid for the pre-order collection, if set. */
    var DATES = {};
    try {
      var dEl = host.querySelector('[data-rv-dates]');
      if (dEl && dEl.textContent) DATES = JSON.parse(dEl.textContent) || {};
    } catch (e) { DATES = {}; }

    function releaseFor(handle) {
      var v = DATES[handle];
      if (!v) return null;
      var t = new Date(v + 'T00:00:00');
      return isNaN(t.getTime()) ? null : t;
    }
    function fmtRelease(d) {
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB',
          { day: 'numeric', month: 'short' }).format(d);
      } catch (e) { return ''; }
    }

    function cardHTML(p, seenMap) {
      var th = themeFor(p);
      var hay = [p.title, p.type, (p.tags || []).join(' ')].join(' ').toLowerCase();
      var pre = /pre[\s-]?order|coming soon|allocation/.test(hay);
      var single = isSingleCard(p, hay);

      /* A pre-order sitting at zero stock is not "sold out" — it has not been
         released yet. Where a release date is known, it decides: still ahead
         means coming soon, already passed means it really has sold out. With
         no date, the Pre-Order tag alone is enough to hold off the sold-out
         label, because a released line loses that tag. */
      var rel = releaseFor(p.handle);
      var unreleased = !rel || rel.getTime() > Date.now();
      var comingSoon = pre && !p.available && unreleased;
      var cap = Number(p.compare_at_price) || 0;
      var sale = cap > 0 && cap > p.price;
      var pct = sale ? Math.round((cap - p.price) / cap * 100) : 0;
      var imgs = p.images && p.images.length ? p.images : (p.featured_image ? [p.featured_image] : []);
      var alt = cfg.second && imgs.length > 1;
      var url = p.url || ('/products/' + p.handle);

      var qty = 0;
      (p.variants || []).forEach(function (v) {
        if (typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0) qty += v.inventory_quantity;
      });
      var low = cfg.low > 0 && p.available && qty > 0 && qty <= cfg.low;

      /* One state chip, most urgent wins. Coming soon outranks sold out. */
      var state = '';
      if (cfg.states) {
        if (comingSoon)        state = chip('coming', cfg.comingLabel);
        else if (!p.available) state = chip('sold', 'Sold out');
        else if (pre)          state = chip('pre', 'Pre-order');
        else if (sale)         state = '<span class="llrv__state" data-s="sale">-' + pct + '%</span>';
        else if (low)          state = chip('low', qty + ' left');
      }

      var meta = '';
      if (cfg.vendor && th) {
        meta += '<span class="llrv__chip">' +
          (th.icon ? '<img src="' + esc(th.icon) + '" alt="" width="11" height="11" loading="lazy" decoding="async">' : '') +
          esc(th.id === 'onepiece' ? 'One Piece' : (th.id === 'magic' ? 'Magic' : th.id)) + '</span>';
      } else if (cfg.vendor && p.vendor) {
        meta += '<span class="llrv__chip">' + esc(p.vendor) + '</span>';
      }
      if (cfg.number && single) {
        var num = cardNumber(p.title);
        if (num) meta += '<span class="llrv__num">' + esc(num) + '</span>';
      }
      if (comingSoon && rel) {
        meta += '<span class="llrv__num">' + esc(fmtRelease(rel)) + '</span>';
      }
      if (cfg.seen) {
        var ago = agoLabel(seenMap[p.handle]);
        if (ago) meta += '<span class="llrv__num">' + esc(ago) + '</span>';
      }

      var price = '';
      if (cfg.price) {
        if (comingSoon) {
          /* Pre-orders are usually priced before they open; show it when set. */
          price = '<div class="llrv__price">' + (p.price > 0
            ? money(p.price)
            : '<span class="out">Price to be confirmed</span>') + '</div>';
        } else if (!p.available) {
          price = '<div class="llrv__price"><span class="out">Sold out</span></div>';
        } else {
          price = '<div class="llrv__price">' + (p.price_varies ? 'From ' : '') + money(p.price) +
            (sale ? '<s>' + money(cap) + '</s>' : '') + '</div>';
        }
      }

      /* Quick add only when there is exactly one buyable variant — anything
         with options goes to the product page rather than guessing. */
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      /* A sealed box is not a card — never label it as one. */
      var noun = single ? 'card' : 'product';
      var cta;
      if (!cfg.qa || !p.available) {
        cta = '<a class="llrv__btn llrv__btn--ghost" href="' + esc(url) + '">View ' + noun + '</a>';
      } else if (vs.length === 1 && (p.variants || []).length === 1) {
        cta = '<button type="button" class="llrv__btn" data-add="' + vs[0].id + '">' +
              '<span class="llrv__spin" aria-hidden="true"></span>' + ICO.cart +
              '<span class="t">' + (pre ? 'Pre-order' : 'Add') + '</span></button>';
      } else {
        cta = '<a class="llrv__btn llrv__btn--ghost" href="' + esc(url) + '">Choose options</a>';
      }

      var bell = '';
      if (cfg.watch) {
        var wOn = !!watchSet[p.handle];
        bell = '<button type="button" class="llrv__bell" data-watch="' + esc(p.handle) + '"' +
               ' aria-pressed="' + (wOn ? 'true' : 'false') + '"' +
               ' aria-label="' + (wOn ? 'Remove from watchlist' : 'Add to watchlist') + '"' +
               ' title="' + (wOn ? 'On your watchlist' : 'Watch for stock and price changes') + '">' +
               ICO.bell + '</button>';
      }

      /* Sold out, but NOT something that has simply not arrived yet: a
         coming-soon pre-order is a future sale, and greying it out would
         read as a dead end on the one card most worth watching. */
      var oos = !p.available && !comingSoon;

      return '<article class="llrv__card' + (alt ? ' has-alt' : '') + (oos ? ' is-oos' : '') + '" role="listitem" data-handle="' + esc(p.handle) + '"' +
        (th ? ' style="--c-acc:' + th.acc + ';--c-ink:' + th.ink + '"' : '') + '>' +
        /* Not an anchor: the title's stretched ::after already makes the whole
           card clickable, and a button cannot live inside a link. */
        '<div class="llrv__media">' +
          imgTag(imgs[0], 'llrv__img1', p.title) +
          (alt ? imgTag(imgs[1], 'llrv__img2', '') : '') +
          '<span class="llrv__flags">' + (state || '<span></span>') +
            '<button type="button" class="llrv__drop" data-drop="' + esc(p.handle) + '"' +
            ' aria-label="Remove ' + esc(p.title) + ' from recently viewed">' + ICO.x + '</button>' +
          '</span>' +
        '</div>' +
        '<div class="llrv__body">' +
          (meta ? '<div class="llrv__meta">' + meta + '</div>' : '') +
          '<h3 class="llrv__name"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3>' +
          price +
        '</div>' +
        '<div class="llrv__cta">' + cta + bell + '</div>' +
      '</article>';
    }

    /* Type tags (IR, Promo, Booster box, JP) from snippets/ll-type-tags,
       through templates/product.ll-tags.liquid: the product JSON this rail is
       drawn from has no metafields. They sit over the photo, so arriving late
       moves nothing; a failure only means a card without them. */
    function addTypeTags(rail, handle) {
      if (!handle || !window.fetch) return;
      fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=ll-tags', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var html = '';
          try { html = JSON.parse(t); } catch (e) { html = ''; }
          if (typeof html !== 'string' || !html) return;
          var cards = rail.querySelectorAll('.llrv__card');
          for (var i = 0; i < cards.length; i++) {
            if (cards[i].getAttribute('data-handle') !== handle) continue;
            var media = cards[i].querySelector('.llrv__media');
            if (!media || media.querySelector('.llrv__tt')) return;
            var span = document.createElement('span');
            span.className = 'llrv__tt';
            span.innerHTML = html;
            media.appendChild(span);
            return;
          }
        })
        .catch(function () {});
    }

    /* ---- rail ---- */
    function syncRail() {
      if (!rail) return;
      var over = rail.scrollWidth - rail.clientWidth;
      if (over <= 4) {
        if (nav) nav.hidden = true;
        rail.removeAttribute('data-edge');
        return;
      }
      if (nav) nav.hidden = false;
      var l = rail.scrollLeft > 4;
      var r = rail.scrollLeft < over - 4;
      rail.setAttribute('data-edge', l && r ? 'both' : (l ? 'left' : 'right'));
      if (prev) prev.disabled = !l;
      if (next) next.disabled = !r;
    }
    function page(dir) {
      if (!rail) return;
      rail.scrollBy({ left: dir * Math.max(rail.clientWidth * 0.8, 200), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    if (rail) {
      var rafId = null;
      rail.addEventListener('scroll', function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () { rafId = null; syncRail(); });
      }, { passive: true });
    }
    var ro = null;
    if (window.ResizeObserver && rail) {
      ro = new ResizeObserver(function () { syncRail(); });
      ro.observe(rail);
    } else {
      window.addEventListener('resize', syncRail);
    }

    /* ---- toast ---- */
    var toastTimer = null;
    function say(msg, withLink, ctx) {
    /* On a product page the page's own toast (window.LLToast, from
       assets/ll-product.js) reports these too, so the page has one toast
       rather than three. Elsewhere this section keeps its own. */
    if (ctx && window.LLToast) {
      var card = ctx.el && ctx.el.closest ? ctx.el.closest('.llrv__card') : null;
      var nm = card && card.querySelector('.llrv__name');
      var im = card && card.querySelector('img');
      var pr = card && card.querySelector('.llrv__price');
      var item = { title: nm ? nm.textContent.replace(/\s+/g, ' ').trim() : '', image: im ? (im.currentSrc || im.src) : '', priceText: pr ? pr.textContent.replace(/\s+/g, ' ').trim() : '' };
      if (ctx.kind === 'add') {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { window.LLToast.cart(item, c); }, function () { window.LLToast.cart(item, null); });
      } else if (ctx.kind === 'watch' || ctx.kind === 'unwatch') {
        window.LLToast.watch(ctx.kind === 'watch', item);
      } else {
        window.LLToast.msg(msg, { tone: 'warn' });
      }
      return;
    }
      if (live) live.textContent = msg;
      if (!toast || !tMsg) return;
      tMsg.textContent = msg;
      if (tLink) tLink.hidden = !withLink;
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3400);
    }

    /* ---- interactions (delegated, survives re-render) ---- */
    function removeCard(handle, msg) {
      writeHist(readHist().filter(function (h) { return h !== handle; }));
      dropCache(handle);
      var card = rail && rail.querySelector('[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
      if (card && card.parentNode) card.parentNode.removeChild(card);
      if (rail && !rail.children.length) { host.hidden = true; return; }
      syncRail();
      if (msg) say(msg, false);
    }

    /* Every selector below is qualified to `button` so a data-* attribute on
       the section root can never be picked up as a card control. */
    host.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;

      var drop = ev.target.closest('button[data-drop]');
      if (drop) {
        ev.preventDefault(); ev.stopPropagation();
        removeCard(drop.getAttribute('data-drop'), 'Removed from recently viewed');
        return;
      }

      var bell = ev.target.closest('button[data-watch]');
      if (bell) {
        ev.preventDefault(); ev.stopPropagation();
        var h = bell.getAttribute('data-watch');
        var list = readWatch();
        var isOn = list.indexOf(h) > -1;
        if (isOn) list = list.filter(function (x) { return x !== h; });
        else list = [h].concat(list);
        writeWatch(list);
        refreshWatchSet();
        paintBells();
        say(isOn ? 'Removed from watchlist' : 'Watching. We will alert you on stock and price changes.', false, { kind: isOn ? 'unwatch' : 'watch', el: ev.target });
        if (window.LLWatchlistLive && window.LLWatchlistLive.refresh) window.LLWatchlistLive.refresh();
        return;
      }

      var add = ev.target.closest('button[data-add]');
      if (add) {
        ev.preventDefault(); ev.stopPropagation();
        if (add.classList.contains('is-busy')) return;
        var id = parseInt(add.getAttribute('data-add'), 10);
        if (!id) return;
        add.classList.add('is-busy');
        fetch(root() + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () {
            add.classList.remove('is-busy');
            add.classList.add('is-done');
            setTimeout(function () { add.classList.remove('is-done'); }, 1500);
            say('Added to basket', true, { kind: 'add', el: add });
            refreshCart();
          })
          .catch(function () {
            add.classList.remove('is-busy');
            say('Could not add this one. Open the product page to try again.', false, { kind: 'fail', el: add });
          });
      }
    });

    function paintBells() {
      if (!rail) return;
      Array.prototype.forEach.call(rail.querySelectorAll('[data-watch]'), function (b) {
        var isOn = !!watchSet[b.getAttribute('data-watch')];
        b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        b.setAttribute('aria-label', isOn ? 'Remove from watchlist' : 'Add to watchlist');
      });
    }

    function refreshCart() {
      fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          ['[data-cart-count]', '.cart-count', '.cart-link__count', '.header__cart-count',
           '.site-header__cart-count', '#CartCount'].forEach(function (sel) {
            Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
              el.textContent = c.item_count;
              if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', c.item_count);
            });
          });
          try { document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: c })); } catch (e) {}
        })
        .catch(function () {});
    }

    var clearBtn = host.querySelector('[data-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () {
      writeHist([]);
      writeJSON(localStorage, K_SEEN, {});
      try {
        for (var i = sessionStorage.length - 1; i >= 0; i--) {
          var k = sessionStorage.key(i);
          if (k && k.indexOf('ll_rvp_') === 0) sessionStorage.removeItem(k);
        }
      } catch (e) {}
      if (rail) rail.innerHTML = '';
      host.hidden = true;
    });

    /* Watchlist changes from a hub, the watchlist page or another tab. */
    document.addEventListener('ll:watchlist:change', function () { refreshWatchSet(); paintBells(); });
    window.addEventListener('storage', function (e) {
      if (!e || (e.key !== K_WATCH && e.key !== K_LEGACY)) return;
      refreshWatchSet(); paintBells();
    });

    /* ---- render ---- */
    host.hidden = false;
    if (rail) {
      var skel = '';
      for (var i = 0; i < Math.min(queue.length, 6); i++) {
        skel += '<div class="llrv__skel"><div class="m"></div><div class="l"></div><div class="l s"></div></div>';
      }
      rail.innerHTML = skel;
    }

    Promise.all(queue.map(fetchProduct)).then(function (items) {
      /* Products that 404 are gone from the store — drop them from history
         instead of leaving dead handles to be re-fetched on every page. */
      var dead = items.filter(function (p) { return p && p.__dead; }).map(function (p) { return p.__dead; });
      if (dead.length) {
        writeHist(readHist().filter(function (h) { return dead.indexOf(h) < 0; }));
        dead.forEach(dropCache);
      }
      var good = items.filter(function (p) { return p && !p.__dead && p.handle; });
      if (!good.length) { host.hidden = true; return; }

      var seenMap = readSeenMap();
      if (rail) rail.innerHTML = good.map(function (p) { return cardHTML(p, seenMap); }).join('');
      if (rail) good.forEach(function (p) { addTypeTags(rail, p.handle); });
      syncRail();
      requestAnimationFrame(syncRail);
    });

    /* Theme editor swaps section markup — release observers on teardown. */
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.contains(host)) return;
      if (ro) ro.disconnect();
      clearTimeout(toastTimer);
      host.__llrv = false;
    });
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll(SECTION);
    Array.prototype.forEach.call(nodes, boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
